var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"role"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h4',[_vm._v(_vm._s(_vm.name))]),_c('div',[_vm._t("after-name")],2)]),_c('p',[_vm._v(_vm._s(_vm.role.description))]),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('roles.subroles')))]),_c('span',[_vm._v(_vm._s(_vm.subRoles))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }